import { Store } from 'redux';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { injectVideoLogo, injectVideoLogoParams } from '../../store/primaryHeader/primaryHeader.actions';
import {
    GET_PAGE_DATA,
    INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY, INJECT_BUTTON_TO_FOOTER_LINKS_SECTION, INJECT_VIDEO_LOGO,
} from './index';
import {
    InjectArticleBlockByIndexArrayParams,
    injectArticleBlockByIndexArray,
} from '../../store/template/postPage/postPage.actions';
import { getLanguage, getSiteName } from '../../store/config/config.selectors';
import { getBlockNames, getCommercialTags } from '../../store/template/postPage/postPage.selectors';
import {
    injectButtonToFooterLinksSection,
    injectButtonToFooterLinksSectionParams,
} from '../../store/footer/footer.actions';
import { getCountryCode } from '../../templates/templates.utils';

const createPageData = (state: AppState) => ({
    siteName: getSiteName(state),
    countryCode: getCountryCode(),
    blockNames: getBlockNames(state),
    language: getLanguage(state),
    tags: getCommercialTags(state),
});

export const injectVideoLogoEvent = {
    name: INJECT_VIDEO_LOGO,
    handlerCreator: (store: Store<AppState, AppActions>) => (params:injectVideoLogoParams) => store.dispatch(injectVideoLogo(params)),
};

export const getPageDataEvent = {
    name: GET_PAGE_DATA,
    handlerCreator: (store: Store<AppState, AppActions>) => (callback: Function) => callback(createPageData(store.getState())),
};

export const injectArticleBlockByIndexArrayEvent = {
    name: INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectArticleBlockByIndexArrayParams) => store.dispatch(injectArticleBlockByIndexArray(params)),
};

export const injectButtonToFooterLinksSectionEvent = {
    name: INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
    handlerCreator: (store: Store<AppState, AppActions>) => (params:injectButtonToFooterLinksSectionParams) => store.dispatch(injectButtonToFooterLinksSection(params)),
};
